<script setup lang="ts">
import { type InlineTable, type ModuleConfiguration } from "@/vf"
import VfComposeInlineTable from "./VfComposeInlineTable.vue"

withDefaults(
    defineProps<{
        config?: ModuleConfiguration
        inlineTable: InlineTable
        rowId: string
        colspan?: number
    }>(),
    {
        colspan: 1,
        config: undefined,
    },
)
</script>

<template>
    <tr class="open-row">
        <td :colspan="colspan" class="p-0">
            <VfComposeInlineTable v-bind="{ inlineTable, rowId, config }">
                <template #default="{ loadedComponent }">
                    <div class="open-row-container">
                        <slot>
                            <component :is="loadedComponent.component" v-bind="loadedComponent.model"></component>
                        </slot>
                    </div>
                </template>
            </VfComposeInlineTable>
        </td>
    </tr>
</template>
